import Page from "components/base/Page";

const SalesDashboard = () => {
  return (
    <Page title="Sales Dashboard">
      <div className="p-6">
        <div className="text-sm opacity-70">
          More details and features will be added here in the future.
        </div>
      </div>
    </Page>
  );
};

export default SalesDashboard;
